import { render, staticRenderFns } from "./GroupFinalMarksCountReportTable.vue?vue&type=template&id=0c033cb6&"
import script from "./GroupFinalMarksCountReportTable.vue?vue&type=script&lang=js&"
export * from "./GroupFinalMarksCountReportTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupFinalMarksCountReportTable.vue?vue&type=style&index=0&id=0c033cb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports